import { ErrorAlertEventSchema } from '@eigtech/alerts-types';
import { z } from 'zod';
export const VeriskEdiImportProcessingFailedAlertEventSchema = ErrorAlertEventSchema.extend({
    type: z.literal('alert:error:veriskEdiImportProcessingFailed'),
    metadata: z.object({
        service: z.literal('verisk-edi-interface'),
    }),
});
